"use strict";

jQuery(function () {
  jQuery('.jsMissionSlider').slick({
    "setting-name": "setting-value",
    'dots': false,
    'infinite': true,
    'speed': 500,
    'slidesToShow': 1,
    'slidesToScroll': 1,
    'adaptiveHeight': false,
    'autoplay': true,
    'autoplaySpeed': 5000,
    'arrows': false,
    'focusOnSelect': false,
    'lazyLoaded': true,
    'fade': true,
    'cssEase': 'linear',
    //'centerMode': true,
    //'centerPadding': '250px',
    'responsive': [{
      'breakpoint': 1200,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'infinite': true,
        'dots': false,
        'centerMode': false,
        'autoplay': true,
        'autoplaySpeed': 5000
      }
    }, {
      'breakpoint': 1200,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'centerMode': false,
        'autoplay': true,
        'autoplaySpeed': 5000
      }
    }, {
      'breakpoint': 600,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'centerMode': false,
        'autoplay': true,
        'autoplaySpeed': 5000
      }
    } // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
  });
  /**
   * Custom buttons to move through the farm-locator slider
   */

  jQuery('.jsMissionNext').on('click', function (e) {
    e.preventDefault();
    jQuery('.jsMissionSlider').slick('slickNext');
  });
  jQuery('.jsMissionPrev').on('click', function (e) {
    e.preventDefault();
    jQuery('.jsMissionSlider').slick('slickPrev');
  });
  jQuery('.jsVisionSlider').slick({
    "setting-name": "setting-value",
    'dots': false,
    'infinite': true,
    'speed': 500,
    'slidesToShow': 1,
    'slidesToScroll': 1,
    'adaptiveHeight': false,
    'autoplay': true,
    'autoplaySpeed': 5000,
    'arrows': false,
    'focusOnSelect': false,
    'lazyLoaded': true,
    'fade': true,
    'cssEase': 'linear',
    //'centerMode': true,
    //'centerPadding': '250px',
    'responsive': [{
      'breakpoint': 1200,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'infinite': true,
        'dots': false,
        'centerMode': false,
        'autoplay': true,
        'autoplaySpeed': 5000
      }
    }, {
      'breakpoint': 1200,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'centerMode': false,
        'autoplay': true,
        'autoplaySpeed': 5000
      }
    }, {
      'breakpoint': 600,
      'settings': {
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'centerMode': false,
        'autoplay': true,
        'autoplaySpeed': 5000
      }
    } // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
    ]
  });
  /**
   * Custom buttons to move through the farm-locator slider
   */

  jQuery('.jsVisionNext').on('click', function (e) {
    e.preventDefault();
    jQuery('.jsVisionSlider').slick('slickNext');
  });
  jQuery('.jsVisionPrev').on('click', function (e) {
    e.preventDefault();
    jQuery('.jsVisionSlider').slick('slickPrev');
  });
});